import { Link, useLocation } from 'react-router-dom';

import { useAuth, useLogout } from '@/features/auth';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';

import { NotificationBell } from './NotificationBell';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';

interface HeaderUserActionsProps {
  /** 알림 종을 감춘다. 도움말처럼 알림과 관계없는 화면에서. */
  showNotifications?: boolean;
  className?: string;
}

/**
 * 헤더 오른쪽 공통 묶음 — 테마 토글 + (로딩 / 로그인됨 / 비로그인).
 *
 * 헤더마다 이 분기를 각자 쓰면 한쪽만 고쳐지고 갈라진다. 특히 `loading` 자리에
 * 스켈레톤을 안 두면 인증 응답이 도착할 때 헤더 오른쪽이 밀려 레이아웃이 튄다.
 */
export function HeaderUserActions({
  showNotifications = true,
  className = '',
}: HeaderUserActionsProps) {
  const location = useLocation();
  const { isAuthenticated, loading, user } = useAuth();
  const { mutate: logout } = useLogout();

  return (
    <div className={`flex items-center gap-2 sm:gap-3 ${className}`}>
      <ThemeToggle />
      {loading ? (
        <div className="hidden h-5 w-16 animate-pulse rounded bg-black/[0.06] sm:block dark:bg-white/10" />
      ) : isAuthenticated ? (
        <>
          {showNotifications && <NotificationBell />}
          <UserMenu user={user!} onLogout={() => logout()} />
        </>
      ) : (
        <Link
          to={PATHS.LOGIN}
          state={{ from: location }}
          className="hidden text-[15px] font-semibold text-neutral-950/60 transition-colors hover:text-neutral-950 sm:inline dark:text-white/60 dark:hover:text-white"
        >
          로그인
        </Link>
      )}
    </div>
  );
}
